'use client';

import { c as _c } from "react/compiler-runtime";
import { LoadingIndicator } from '@petsmart-ui/sparky';
import { useCvvChallenge } from './CVVChallengeProvider';
import { CvvForm } from './CvvForm';
import type { CVVChallengeProps } from './types';
import { useCvvForm } from './useCvvForm';
import '@adyen/adyen-web/styles/adyen.css';
import './CVVChallenge.scss';
export function CVVChallenge(t0) {
  const $ = _c(11);
  const {
    card,
    address,
    onVerified
  } = t0;
  const {
    isLoading
  } = useCvvChallenge();
  let t1;
  if ($[0] !== card || $[1] !== onVerified) {
    t1 = {
      card,
      onVerified
    };
    $[0] = card;
    $[1] = onVerified;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    isSubmitting,
    errorMessage,
    submitCvv,
    clearError
  } = useCvvForm(t1);
  let t2;
  if ($[3] !== address || $[4] !== card || $[5] !== clearError || $[6] !== errorMessage || $[7] !== isLoading || $[8] !== isSubmitting || $[9] !== submitCvv) {
    t2 = <div className="cvv-challenge" data-testid="cvv-challenge">{isLoading ? <LoadingIndicator data-testid="cvv-challenge-loading" /> : <CvvForm card={card} address={address} isSubmitting={isSubmitting} errorMessage={errorMessage} onSubmit={submitCvv} onCvvChange={clearError} />}</div>;
    $[3] = address;
    $[4] = card;
    $[5] = clearError;
    $[6] = errorMessage;
    $[7] = isLoading;
    $[8] = isSubmitting;
    $[9] = submitCvv;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}